import React from 'react';

import { Box, Button, Grid, Tooltip } from '@material-ui/core';

import { Container, MenuContainer, MenuItemStyled, Image, LinkStyled, ImageContainer, ButtonStyled } from './styles';

// import ArrowUpsideEnd from 'assets/navbar-menu-top-perfil.png';
// import AarrowUpside from 'assets/navbar-menu-top.png';
import AarrowUpside from 'assets/arrowUpside.svg';
import ArrowUpsideEnd from 'assets/ArrowUpsideEnd.svg';
import { TypographyCN } from 'components/atoms/Typograph';
import { theme } from 'styles';

interface TooltipedTextProps {
  children: any;
  fullText?: string;
  reverseImage?: boolean;
  placement?: 'top' | 'bottom' | 'bottom-start' | 'left' | 'right' | 'top-start' | 'top-end';
  arrow?: boolean;
  onClick?: any;
  handleClose?: any;
  anchorEl?: any;
  data: {
    id: number;
    name: string;
    url: string;
    icon: React.ReactElement;
  }[];
  onExit?: () => void;
  buttonColor?: string;
  openDrawerMobile?: () => void;
}

export function TooltipedButton({
  children,
  fullText,
  placement,
  arrow,
  onClick,
  handleClose,
  anchorEl,
  data,
  onExit,
  buttonColor,
  reverseImage = false,
  openDrawerMobile,
}: TooltipedTextProps) {
  const propsPasswordButton = {
    onClick: openDrawerMobile,
  };

  return (
    <>
      <Tooltip
        title={fullText || ''}
        placement={placement}
        arrow={arrow}
        style={{
          transform: 'translateX(100px)',
        }}
      >
        <Button
          style={{ margin: 0, backgroundColor: buttonColor, borderRadius: '0.5rem' }}
          aria-controls="simple-menu"
          aria-haspopup="true"
          onClick={onClick}
        >
          <Container>{children}</Container>
        </Button>
      </Tooltip>

      <MenuContainer
        id="simple-menu"
        anchorEl={anchorEl}
        keepMounted
        open={Boolean(anchorEl)}
        onClose={handleClose}
        style={{
          borderRadius: '10px',
          marginLeft: '1.5rem',
        }}
      >
        <div style={{ lineHeight: 0, paddingTop: 3, width: '100%' }}>
          <Image src={reverseImage ? ArrowUpsideEnd : AarrowUpside} alt="ArrowUpside" style={{ width: '100%' }} />
        </div>
        <Grid
          style={{
            background: theme.palette.primary.main,
            paddingBottom: theme.spacing(1),
            marginTop: -2, // Se nao tiver esse margin top negativo o svg fica com uma linha em baixo ja tentei remover isso pelo figma mas nao funciona :s
          }}
        >
          {data?.map(value => (
            <MenuItemStyled
              key={value.id}
              onClick={handleClose}
              disableRipple
              style={
                {
                  // marginTop: value.id === 1 ? (fullText === 'Perfil' ? '1rem' : '1rem') : 0,
                }
              }
            >
              {value.name === 'Sair' ? (
                <LinkStyled to={value.url} onClick={onExit}>
                  {value.icon}

                  <span
                    style={{
                      minWidth: '105px',
                    }}
                  >
                    {value.name}
                  </span>
                </LinkStyled>
              ) : (
                <>
                  {value.name === 'Alterar Senha' ? (
                    <ButtonStyled
                      variant="text"
                      disableRipple
                      {...(openDrawerMobile && value.name === 'Alterar Senha'
                        ? propsPasswordButton
                        : { to: value.url })}
                    >
                      {value.icon}

                      <TypographyCN
                        text={value.name}
                        color="inherit"
                        weight="medium"
                        style={{
                          fontSize: 16,
                          minWidth: '105px',
                        }}
                      />
                    </ButtonStyled>
                  ) : (
                    <LinkStyled to={value.url}>
                      {value.icon}

                      <TypographyCN
                        text={value.name}
                        color="inherit"
                        weight="medium"
                        style={{
                          fontSize: 16,
                          minWidth: '105px',
                        }}
                      />
                    </LinkStyled>
                  )}
                </>
              )}
            </MenuItemStyled>
          ))}
        </Grid>
      </MenuContainer>
    </>
  );
}
